export const colors = {
    primary: {
        main: "#C51919",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#EDEDED",
        contrast: "#333333",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#B3B3B3",
        disabled: "#898989",
    },
    text: {
        main: "#333333",
        disabled: "#898989",
        accent: "#2D3435",
        link: "#C51919",
    },
    success: {
        main: "#3DB971",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#E64E25",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#FEC111",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#13A2B9",
        contrast: "#FFFFFF",
    },
};